// If VITE_API_BASE_PATH is provided, use it as the origin/path prefix and append '/api'.
// Trim any trailing slash on the configured base so we don't produce '...//api'.
const configuredBase = import.meta.env.VITE_API_BASE_PATH;
const API_BASE_PATH = configuredBase && configuredBase !== ''
	? `${configuredBase.replace(/\/$/, '')}/api`
	: '/api';

export default API_BASE_PATH;